import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { LoadState_map, LoadState$2, SaveStatus as SaveStatus_4, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type, lambda_type, unit_type, class_type, string_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ContractType$reflection } from "../Invoicee/Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { decimalToTwoDecimals, classNames, DateTimeOffsetExtensions_toUtc, formatUrl, DateTimeExtensions_toDateHHmm, stackClasses, DateTimeOffsetExtensions_to1stInMonth, Locale_get_FromSelectedLanguage } from "../../Utils.js";
import { useSelector, useDispatch } from "../../Redux/Store.js";
import * as react from "react";
import { fromDate, addMonths, now } from "../../fable_modules/fable-library.3.7.20/DateOffset.js";
import { toList } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { head, tail, forAll, isEmpty, singleton, ofArray, filter, cons, length, sort, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { uncurry, equals, comparePrimitives, numberHash, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ProductModule_ofInt, ProductModule_toTranslation } from "../../DomainTypes.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, DateOptions, DateOptions_get_getDefault, inputDate, SelectOption, ValueProp as ValueProp_2, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Checked, Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { Locale, EnableTimePicker, FormatDateBy, OnChange as OnChange_2, Value as Value_1, ClassName, Id as Id_8 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { fromDateTimeOffset } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { modalCancel, modalMain, ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { ModalSize, getModalContainer, getModalFooterContainer, getModalBodyContainer, getModalHeader } from "../../Components/Modal/Modal.js";
import { append, singleton as singleton_1, delay, toList as toList_1 } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { info, warning, error } from "../../Components/Message/Message.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { getSavePanel } from "../../Components/SavePanel/SavePanel.js";
import { ChangeContractTypeSuggestion, StartingFee, EndingFee, ChangeContractTypeDTO } from "./Model.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadChangeContractType, saveChangeContractType as saveChangeContractType_2 } from "./Api.js";
import { printf, toText, isNullOrWhiteSpace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { setItem, getItem } from "../../LocalStorage.js";
import { dotsLoading } from "../../ViewUtils.js";
import "../../../src/Containers/UpdateContractType/View.scss";


export class ChangeContractModalProps extends Record {
    constructor(GlobalDependencies, ContractNr, ContractTypes, CloseModalFn, AfterSaveFn) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.ContractTypes = ContractTypes;
        this.CloseModalFn = CloseModalFn;
        this.AfterSaveFn = AfterSaveFn;
    }
}

export function ChangeContractModalProps$reflection() {
    return record_type("Containers.UpdateContractType.View.ChangeContractModalProps", [], ChangeContractModalProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["AfterSaveFn", lambda_type(unit_type, unit_type)]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props_99) => {
    let copyOfStruct, inputRecord, LabelText, inputRecord_1, inputRecord_2, LabelText_2, copyOfStruct_1, children_15, matchValue_5, children_17, copyOfStruct_2, inputRecord_3, LabelText_3, contractTypes_2, inputRecord_4, inputRecord_5, Value, inputRecord_6, LabelText_6, copyOfStruct_3, children_62, children_66, children_71, children_75, children_53, children_57, children_92, matchValue_22, children_94;
    if (props_99.GlobalDependencies.ClientNr === 46965) {
        const props = props_99;
        const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
        const reduxDispatch = useDispatch();
        const translationsLoadState = useSelector((state) => state.Model.Translations);
        const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
        const saveStatusState = react.useState(new SaveStatus_4(0));
        const selectedProductState = react.useState("");
        const selectedContractTypeCodeState = react.useState("");
        const isDateFlashingState = react.useState(false);
        const selectedStartDateState = react.useState(DateTimeOffsetExtensions_to1stInMonth((copyOfStruct = now(), addMonths(copyOfStruct, 1))));
        react.useEffect(() => {
        const disp = (() => {
            const matchValue = isDateFlashingState[0];
            if (matchValue) {
                const timer = window.setTimeout(() => {
                    isDateFlashingState[1](false);
                }, 1500);
                return {
                    Dispose() {
                        window.clearTimeout(timer);
                    },
                };
            }
            else {
                return {
                    Dispose() {
                    },
                };
            }
        })();
        return () => disp.Dispose();
    }, [isDateFlashingState[0]]);
        let bodyHtml;
        const contractTypes = toList(props.ContractTypes);
        const productsToDisplay = map((product) => [int32ToString(product), ProductModule_toTranslation(getTranslation, ProductModule_ofInt(product))], sort(List_distinct(map((tupledArg) => tupledArg[1].ProductNr, contractTypes), {
            Equals: (x, y) => (x === y),
            GetHashCode: numberHash,
        }), {
            Compare: comparePrimitives,
        }));
        const shouldDisplayProducts = length(productsToDisplay) > 1;
        const productInputHtml = shouldDisplayProducts ? selectOption((inputRecord = SelectOption_get_getDefault(), (LabelText = getTranslation("Common.ProductType"), new SelectOption(new ValueProp_2(0, selectedProductState[0], (e) => {
            const arg_2 = Browser_Types_Event__Event_get_Value(e);
            selectedProductState[1](arg_2);
        }), "update-contract-type-select-product", cons(["", getTranslation("Common.ChooseProductType")], productsToDisplay), inputRecord.Classes, LabelText, inputRecord.Disabled, inputRecord.HTMLProps)))) : react.createElement(react.Fragment, {});
        const contractTypeOptions = map((tupledArg_3) => [tupledArg_3[0], tupledArg_3[1].Display], filter((tupledArg_2) => tupledArg_2[1].Active, (shouldDisplayProducts && ((selectedProductState[0]) !== "")) ? filter((tupledArg_1) => (int32ToString(tupledArg_1[1].ProductNr) === (selectedProductState[0])), contractTypes) : contractTypes));
        let contractTypeInputHtml;
        const contractTypeSelectOptionHtml = selectOption((inputRecord_1 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_2(0, selectedContractTypeCodeState[0], (e_1) => {
            const arg_3 = Browser_Types_Event__Event_get_Value(e_1);
            selectedContractTypeCodeState[1](arg_3);
        }), "update-contract-type-select-contract-type", cons(["", getTranslation("Common.ChooseSubscription")], contractTypeOptions), inputRecord_1.Classes, getTranslation("Common.SubscriptionForm"), inputRecord_1.Disabled, inputRecord_1.HTMLProps)));
        const props_2 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
        contractTypeInputHtml = react.createElement("div", keyValueList(props_2, 1), contractTypeSelectOptionHtml);
        let dateSectionHtml;
        const startDateHtml = inputDate((inputRecord_2 = DateOptions_get_getDefault(), (LabelText_2 = getTranslation("Common.StartDate"), new DateOptions(ofArray([Id_8("update-contract-type-start-date"), ClassName((isDateFlashingState[0]) ? "input__date input__date--with-icon flatpickr-input date-flash" : "input__date input__date--with-icon flatpickr-input"), Value_1((copyOfStruct_1 = (selectedStartDateState[0]), fromDateTimeOffset(copyOfStruct_1, 0))), OnChange_2((arg_6) => {
            const arg_5 = fromDate(arg_6);
            selectedStartDateState[1](arg_5);
        }), FormatDateBy((date_2) => DateTimeExtensions_toDateHHmm(locale.ILocale, date_2)), EnableTimePicker(true), Locale(locale.FlatpickrLocale)]), LabelText_2, true, inputRecord_2.Disabled, inputRecord_2.OnClearClick))));
        const todayButtonHtml = wrappedButton(new ButtonKind(1), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.Today"), defaultProps.Content, (_arg_6) => {
            const arg_7 = now();
            selectedStartDateState[1](arg_7);
            isDateFlashingState[1](true);
        }, defaultProps.Disabled, "update-contract-type-today-button", defaultProps.SaveStatus, defaultProps.HTMLProps, singleton("ml-2"), defaultProps.Icon));
        const props_4 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
        dateSectionHtml = react.createElement("div", keyValueList(props_4, 1), startDateHtml, todayButtonHtml);
        bodyHtml = react.createElement(react.Fragment, {}, productInputHtml, contractTypeInputHtml, dateSectionHtml);
        const modalHeaderHtml = getModalHeader(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType"), (_arg_7) => {
            props.CloseModalFn();
        });
        const modalBodyHtml = getModalBodyContainer((children_15 = toList_1(delay(() => {
            let children_14;
            const matchValue_2 = saveStatusState[0];
            switch (matchValue_2.tag) {
                case 1:
                case 3:
                case 2: {
                    let errorMessageHtml;
                    const matchValue_3 = saveStatusState[0];
                    if (matchValue_3.tag === 3) {
                        const children_6 = [error(matchValue_3.fields[0].split(""))];
                        errorMessageHtml = react.createElement("div", {
                            className: "d-flex justify-content-center pb-4",
                        }, ...children_6);
                    }
                    else {
                        errorMessageHtml = react.createElement(react.Fragment, {});
                    }
                    const historyLink = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), ofArray(["Subscriptions", int32ToString(props.ContractNr)]), singleton("History")), 1);
                    return singleton_1((children_14 = toList_1(delay(() => append(singleton_1(getSavePanel("", singleton([(getTranslation("Common.Changing") + " ") + getTranslation("Common.SubscriptionForm"), saveStatusState[0]]))), delay(() => {
                        let children_11, children_9;
                        return append(((saveStatusState[0]).tag === 2) ? singleton_1((children_11 = [(children_9 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.GoToPlannedChanges")], react.createElement("a", {
                            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.GoToPlannedChanges",
                            onClick: (_arg_8) => {
                                props.CloseModalFn();
                            },
                            id: "update-contract-type-navigate-history",
                            href: historyLink,
                        }, ...children_9))], react.createElement("p", {}, ...children_11))) : singleton_1(react.createElement(react.Fragment, {})), delay(() => singleton_1(errorMessageHtml)));
                    })))), react.createElement(react.Fragment, {}, ...children_14)));
                }
                default: {
                    return singleton_1(bodyHtml);
                }
            }
        })), react.createElement("div", {
            className: "update-contract-type__form",
        }, ...children_15)));
        const modalFooterHtml = getModalFooterContainer((matchValue_5 = (saveStatusState[0]), (matchValue_5.tag === 1) ? modalMain(new ButtonProps(getTranslation("Common.Changing") + "...", defaultProps.Content, (value_2) => {
        }, true, defaultProps.Id, saveStatusState[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((matchValue_5.tag === 3) ? modalMain(new ButtonProps(getTranslation("Common.Close"), defaultProps.Content, (_arg_11) => {
            props.AfterSaveFn();
            props.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, saveStatusState[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((matchValue_5.tag === 2) ? modalMain(new ButtonProps(getTranslation("Common.Close"), defaultProps.Content, (_arg_11) => {
            props.AfterSaveFn();
            props.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, saveStatusState[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((children_17 = [modalCancel(new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_9) => {
            props.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalMain(new ButtonProps(getTranslation("Common.Change"), defaultProps.Content, (_arg_10) => {
            const startDate = selectedStartDateState[0];
            const newContractTypeCode = selectedContractTypeCodeState[0];
            saveStatusState[1](new SaveStatus_4(1));
            const dto = new ChangeContractTypeDTO(DateTimeOffsetExtensions_toUtc(startDate), void 0, void 0);
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(saveChangeContractType_2(props.GlobalDependencies.ClientNr, props.ContractNr, newContractTypeCode, dto), (_arg) => {
                const result = _arg;
                const arg = (result.tag === 1) ? (new SaveStatus_4(3, result.fields[0])) : (new SaveStatus_4(2));
                saveStatusState[1](arg);
                return singleton_2.Zero();
            })));
        }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement(react.Fragment, {}, ...children_17)))))));
        return getModalContainer(new ModalSize(2), react.createElement("div", {
            className: "update-contract-type",
        }, modalHeaderHtml, modalBodyHtml, modalFooterHtml));
    }
    else {
        const props_21 = props_99;
        const locale_2 = Locale_get_FromSelectedLanguage()(props_21.GlobalDependencies.SelectedLanguage);
        const reduxDispatch_1 = useDispatch();
        const translationsLoadState_1 = useSelector((state_1) => state_1.Model.Translations);
        const getTranslation_1 = (key_2) => getTranslationFrom(translationsLoadState_1, key_2);
        const saveStatusState_1 = react.useState(new SaveStatus_4(0));
        const selectedProductState_1 = react.useState("");
        const selectedContractTypeCodeState_1 = react.useState("");
        const isDateFlashingState_1 = react.useState(false);
        const contractTypeSuggestionState = react.useState(new LoadState$2(0));
        const selectedStartDateState_1 = react.useState(DateTimeOffsetExtensions_to1stInMonth((copyOfStruct_2 = now(), addMonths(copyOfStruct_2, 1))));
        const moreThanOneStartingFeesSelected = react.useMemo(() => {
            const matchValue_6 = contractTypeSuggestionState[0];
            return (matchValue_6.tag === 2) && (1 < length(filter((fee) => fee.IsSelected, matchValue_6.fields[0].StartingFees)));
        }, [contractTypeSuggestionState[0]]);
        const moreThanOneEndingFeesSelected = react.useMemo(() => {
            const matchValue_7 = contractTypeSuggestionState[0];
            return (matchValue_7.tag === 2) && (1 < length(filter((fee_1) => fee_1.IsSelected, matchValue_7.fields[0].EndingFees)));
        }, [contractTypeSuggestionState[0]]);
        const requiredNrOfFeesSelected = react.useMemo(() => {
            const matchValue_8 = contractTypeSuggestionState[0];
            if (matchValue_8.tag === 2) {
                const suggestions_2 = matchValue_8.fields[0];
                const matchValue_9 = (!isEmpty(suggestions_2.StartingFees)) && (!isEmpty(suggestions_2.EndingFees));
                if (matchValue_9) {
                    const hasExactlyOneStartingFeeSelected = 1 === length(filter((fee_2) => fee_2.IsSelected, suggestions_2.StartingFees));
                    const hasExactlyOneEndingFeeSelected = 1 === length(filter((fee_3) => fee_3.IsSelected, suggestions_2.EndingFees));
                    const hasZeroStartingFeesSelected = forAll((fee_4) => (!fee_4.IsSelected), suggestions_2.StartingFees);
                    return (hasExactlyOneEndingFeeSelected && hasExactlyOneStartingFeeSelected) ? true : (forAll((fee_5) => (!fee_5.IsSelected), suggestions_2.EndingFees) && hasZeroStartingFeesSelected);
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }, [contractTypeSuggestionState[0]]);
        const saveChangeContractType_1 = (newContractTypeCode_1, startDate_1, endingFeeNr_1, startingFeeTemplateNr_1) => {
            saveStatusState_1[1](new SaveStatus_4(1));
            const dto_1 = new ChangeContractTypeDTO(DateTimeOffsetExtensions_toUtc(startDate_1), endingFeeNr_1, startingFeeTemplateNr_1);
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(saveChangeContractType_2(props_21.GlobalDependencies.ClientNr, props_21.ContractNr, newContractTypeCode_1, dto_1), (_arg_12) => {
                const result_1 = _arg_12;
                const arg_9 = (result_1.tag === 1) ? (new SaveStatus_4(3, result_1.fields[0])) : (new SaveStatus_4(2));
                saveStatusState_1[1](arg_9);
                return singleton_2.Zero();
            })));
        };
        react.useEffect(() => {
            if (isNullOrWhiteSpace(selectedContractTypeCodeState_1[0])) {
            }
            else {
                const newContractTypeCode_2 = selectedContractTypeCodeState_1[0];
                contractTypeSuggestionState[1](new LoadState$2(1));
                startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadChangeContractType(props_21.GlobalDependencies.ClientNr, props_21.ContractNr, newContractTypeCode_2), (_arg_13) => {
                    let endingFeesShouldBeSelected, startingFeesShouldBeSelected;
                    const result_2 = _arg_13;
                    let arg_12;
                    if (result_2.tag === 1) {
                        arg_12 = (new LoadState$2(3, result_2.fields[0]));
                    }
                    else {
                        const dto_2 = result_2.fields[0];
                        arg_12 = (new LoadState$2(2, (endingFeesShouldBeSelected = (length(dto_2.EndingFees) < 2), (startingFeesShouldBeSelected = (length(dto_2.StartingFees) < 2), new ChangeContractTypeSuggestion(map((fee_8) => (new EndingFee(fee_8.Description, fee_8.FeeNr, fee_8.Amount, endingFeesShouldBeSelected)), dto_2.EndingFees), map((fee_9) => (new StartingFee(fee_9.Description, fee_9.FeeTemplateNr, fee_9.Amount, startingFeesShouldBeSelected)), dto_2.StartingFees))))));
                    }
                    contractTypeSuggestionState[1](arg_12);
                    return singleton_2.Zero();
                })));
            }
        }, [selectedContractTypeCodeState_1[0]]);
        react.useEffect(() => {
        const disp = (() => {
            const matchValue_11 = isDateFlashingState_1[0];
            if (matchValue_11) {
                const timer_1 = window.setTimeout(() => {
                    isDateFlashingState_1[1](false);
                }, 1500);
                return {
                    Dispose() {
                        window.clearTimeout(timer_1);
                    },
                };
            }
            else {
                return {
                    Dispose() {
                    },
                };
            }
        })();
        return () => disp.Dispose();
    }, [isDateFlashingState_1[0]]);
        let bodyHtml_1;
        let initIncludeInactiveContractTypes;
        const matchValue_12 = getItem("Containers.Subscriptions.UpdateContractType", "IncludeInactiveContractTypes");
        initIncludeInactiveContractTypes = ((matchValue_12 == null) ? false : (matchValue_12 === "true"));
        const includeInactiveContractTypesState = react.useState(initIncludeInactiveContractTypes);
        const contractTypes_1 = toList(props_21.ContractTypes);
        const productsToDisplay_1 = map((product_1) => [int32ToString(product_1), ProductModule_toTranslation(getTranslation_1, ProductModule_ofInt(product_1))], sort(List_distinct(map((tupledArg_6) => tupledArg_6[1].ProductNr, contractTypes_1), {
            Equals: (x_6, y_6) => (x_6 === y_6),
            GetHashCode: numberHash,
        }), {
            Compare: comparePrimitives,
        }));
        const shouldDisplayProducts_1 = length(productsToDisplay_1) > 1;
        const productInputHtml_1 = shouldDisplayProducts_1 ? selectOption((inputRecord_3 = SelectOption_get_getDefault(), (LabelText_3 = getTranslation_1("Common.ProductType"), new SelectOption(new ValueProp_2(0, selectedProductState_1[0], (e_2) => {
            const arg_14 = Browser_Types_Event__Event_get_Value(e_2);
            selectedProductState_1[1](arg_14);
        }), "update-contract-type-select-product", cons(["", getTranslation_1("Common.ChooseProductType")], productsToDisplay_1), inputRecord_3.Classes, LabelText_3, inputRecord_3.Disabled, inputRecord_3.HTMLProps)))) : react.createElement(react.Fragment, {});
        const contractTypeOptions_1 = map((tupledArg_9) => [tupledArg_9[0], tupledArg_9[1].Display], (contractTypes_2 = ((shouldDisplayProducts_1 && ((selectedProductState_1[0]) !== "")) ? filter((tupledArg_7) => (int32ToString(tupledArg_7[1].ProductNr) === (selectedProductState_1[0])), contractTypes_1) : contractTypes_1), (includeInactiveContractTypesState[0]) ? contractTypes_2 : filter((tupledArg_8) => tupledArg_8[1].Active, contractTypes_2)));
        let contractTypeInputHtml_1;
        const contractTypeSelectOptionHtml_1 = selectOption((inputRecord_4 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_2(0, selectedContractTypeCodeState_1[0], (e_3) => {
            const arg_15 = Browser_Types_Event__Event_get_Value(e_3);
            selectedContractTypeCodeState_1[1](arg_15);
        }), "update-contract-type-select-contract-type", cons(["", getTranslation_1("Common.ChooseSubscription")], contractTypeOptions_1), inputRecord_4.Classes, getTranslation_1("Common.SubscriptionForm"), inputRecord_4.Disabled, inputRecord_4.HTMLProps)));
        let includeInactiveContractTypesHtml;
        const props_23 = [new HTMLAttr(65, stackClasses(ofArray(["text-nowrap", "ml-4"])))];
        const children_21 = [inputCheckbox((inputRecord_5 = CheckboxInput_get_getDefault(), (Value = (includeInactiveContractTypesState[0]), new CheckboxInput(inputRecord_5.Disabled, getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.ShowInactiveContractTypes"), (e_4) => {
            const shouldInclude = Browser_Types_Event__Event_get_Checked(e_4);
            setItem("Containers.Subscriptions.UpdateContractType", "IncludeInactiveContractTypes", shouldInclude ? "true" : "false");
            includeInactiveContractTypesState[1](shouldInclude);
        }, Value, "update-contract-type-include-inactive", inputRecord_5.HTMLProps))))];
        includeInactiveContractTypesHtml = react.createElement("div", keyValueList(props_23, 1), ...children_21);
        const props_25 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
        contractTypeInputHtml_1 = react.createElement("div", keyValueList(props_25, 1), contractTypeSelectOptionHtml_1, includeInactiveContractTypesHtml);
        let dateSectionHtml_1;
        const startDateHtml_1 = inputDate((inputRecord_6 = DateOptions_get_getDefault(), (LabelText_6 = getTranslation_1("Common.StartDate"), new DateOptions(ofArray([Id_8("update-contract-type-start-date"), ClassName((isDateFlashingState_1[0]) ? "input__date input__date--with-icon flatpickr-input date-flash" : "input__date input__date--with-icon flatpickr-input"), Value_1((copyOfStruct_3 = (selectedStartDateState_1[0]), fromDateTimeOffset(copyOfStruct_3, 0))), OnChange_2((arg_18) => {
            const arg_17 = fromDate(arg_18);
            selectedStartDateState_1[1](arg_17);
        }), FormatDateBy((date_5) => DateTimeExtensions_toDateHHmm(locale_2.ILocale, date_5)), EnableTimePicker(true), Locale(locale_2.FlatpickrLocale)]), LabelText_6, true, inputRecord_6.Disabled, inputRecord_6.OnClearClick))));
        const todayButtonHtml_1 = wrappedButton(new ButtonKind(1), new ButtonProps(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.Today"), defaultProps.Content, (_arg_19) => {
            const arg_19 = now();
            selectedStartDateState_1[1](arg_19);
            isDateFlashingState_1[1](true);
        }, defaultProps.Disabled, "update-contract-type-today-button", defaultProps.SaveStatus, defaultProps.HTMLProps, singleton("ml-2"), defaultProps.Icon));
        const props_27 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
        dateSectionHtml_1 = react.createElement("div", keyValueList(props_27, 1), startDateHtml_1, todayButtonHtml_1);
        let changesToBeMadeHtml;
        const matchValue_14 = contractTypeSuggestionState[0];
        switch (matchValue_14.tag) {
            case 1: {
                changesToBeMadeHtml = dotsLoading;
                break;
            }
            case 3: {
                changesToBeMadeHtml = error(matchValue_14.fields[0].split(""));
                break;
            }
            case 2: {
                const suggestions_5 = matchValue_14.fields[0];
                const renderRow = (idPrefix, id, desc, amount, isSelected_2, isDisabled, date_6, onChange) => {
                    let children_30, children_32, children_34, inputRecord_7;
                    const keyId = toText(printf("%s%i"))(idPrefix)(id);
                    const dateCellClasses = classNames(ofArray([["fee-container__cell", true], ["date-flash", isDateFlashingState_1[0]]]));
                    const children_36 = [react.createElement("div", {
                        className: "fee-container__cell fee-container__cell--left",
                    }, desc), (children_30 = [decimalToTwoDecimals(amount)], react.createElement("div", {
                        className: "fee-container__cell",
                    }, ...children_30)), (children_32 = [DateTimeExtensions_toDateHHmm(locale_2.ILocale, date_6)], react.createElement("div", {
                        className: dateCellClasses,
                    }, ...children_32)), (children_34 = [inputCheckbox((inputRecord_7 = CheckboxInput_get_getDefault(), new CheckboxInput(isDisabled, inputRecord_7.LabelText, (e_5) => {
                        if (isDisabled) {
                        }
                        else {
                            onChange([id, Browser_Types_Event__Event_get_Checked(e_5)]);
                        }
                    }, isSelected_2, toText(printf("checkbox-%s"))(keyId), inputRecord_7.HTMLProps)))], react.createElement("div", {
                        className: "fee-container__cell fee-container__cell--right",
                    }, ...children_34))];
                    return react.createElement(react.Fragment, {
                        key: keyId,
                    }, ...children_36);
                };
                const renderFeeGrid = (dateTranslation, willTranslation, isDisabled_1, rows) => {
                    let children_37, children_39;
                    const feeContainerClasses = classNames(ofArray([["changes__fee-container", true], ["changes__fee-container--disabled", isDisabled_1]]));
                    const children_46 = [(children_37 = [getTranslation_1("Common.FeeText")], react.createElement("div", {
                        className: "fee-container__header fee-container__header--left",
                    }, ...children_37)), (children_39 = [getTranslation_1("Common.AmountInclVat")], react.createElement("div", {
                        className: "fee-container__header",
                    }, ...children_39)), react.createElement("div", {
                        className: "fee-container__header",
                    }, dateTranslation), react.createElement("div", {
                        className: "fee-container__header fee-container__header--right",
                    }, willTranslation), react.createElement(react.Fragment, {}, ...rows)];
                    return react.createElement("div", {
                        className: feeContainerClasses,
                    }, ...children_46);
                };
                const isDisabled_2 = isEmpty(suggestions_5.EndingFees) ? true : isEmpty(suggestions_5.StartingFees);
                let endingFeesHtml;
                const matchValue_15 = suggestions_5.EndingFees;
                if (isEmpty(matchValue_15)) {
                    endingFeesHtml = warning(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.NoFeesWithAccountNr").split(""));
                }
                else {
                    const rows_1 = map((endingFee) => {
                        let copyOfStruct_4;
                        return renderRow("fee", endingFee.FeeNr, endingFee.Description, endingFee.Amount, endingFee.IsSelected, isDisabled_2, (copyOfStruct_4 = (selectedStartDateState_1[0]), fromDateTimeOffset(copyOfStruct_4, 0)), (tupledArg_4) => {
                            contractTypeSuggestionState[1]((current) => LoadState_map((suggestions_3) => (new ChangeContractTypeSuggestion(map((fee_6) => {
                                if (fee_6.FeeNr === tupledArg_4[0]) {
                                    return new EndingFee(fee_6.Description, fee_6.FeeNr, fee_6.Amount, tupledArg_4[1]);
                                }
                                else {
                                    return fee_6;
                                }
                            }, suggestions_3.EndingFees), suggestions_3.StartingFees)), current));
                        });
                    }, matchValue_15);
                    endingFeesHtml = renderFeeGrid(getTranslation_1("Common.EndDate"), getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.WillEnd"), isDisabled_2, rows_1);
                }
                let startingFees_1;
                const matchValue_16 = suggestions_5.StartingFees;
                if (isEmpty(matchValue_16)) {
                    startingFees_1 = warning(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.NoFeesWithAccountNr").split(""));
                }
                else {
                    const rows_2 = map((startingFee) => {
                        let copyOfStruct_5;
                        return renderRow("feetemplate", startingFee.FeeTemplateNr, startingFee.Description, startingFee.Amount, startingFee.IsSelected, isDisabled_2, (copyOfStruct_5 = (selectedStartDateState_1[0]), fromDateTimeOffset(copyOfStruct_5, 0)), (tupledArg_5) => {
                            contractTypeSuggestionState[1]((current_1) => LoadState_map((suggestions_4) => (new ChangeContractTypeSuggestion(suggestions_4.EndingFees, map((fee_7) => {
                                if (fee_7.FeeTemplateNr === tupledArg_5[0]) {
                                    return new StartingFee(fee_7.Description, fee_7.FeeTemplateNr, fee_7.Amount, tupledArg_5[1]);
                                }
                                else {
                                    return fee_7;
                                }
                            }, suggestions_4.StartingFees))), current_1));
                        });
                    }, matchValue_16);
                    startingFees_1 = renderFeeGrid(getTranslation_1("Common.StartDate"), getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.WillStart"), isDisabled_2, rows_2);
                }
                const cancellationPeriodMonthsAndBoundMonthsMsgHtml = info(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.MoveAndCancellationPeriodBoundMonths").split(""));
                const moreThanOneStartingFeeSelectedMsgHtml = moreThanOneStartingFeesSelected ? error(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.TooManyStartingFees").split("")) : react.createElement(react.Fragment, {});
                const moreThanOneEndingFeeSelectedMsgHtml = moreThanOneEndingFeesSelected ? error(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.TooManyEndingFees").split("")) : react.createElement(react.Fragment, {});
                let requiredNrOfFeesSelectedHtml;
                const matchValue_17 = [requiredNrOfFeesSelected, moreThanOneStartingFeesSelected, moreThanOneEndingFeesSelected];
                let pattern_matching_result;
                if (matchValue_17[0]) {
                    pattern_matching_result = 1;
                }
                else if (matchValue_17[1]) {
                    pattern_matching_result = 1;
                }
                else if (matchValue_17[2]) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 0;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        requiredNrOfFeesSelectedHtml = error(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.RequiredNrOfFeesSelected").split(""));
                        break;
                    }
                    case 1: {
                        requiredNrOfFeesSelectedHtml = react.createElement(react.Fragment, {});
                        break;
                    }
                }
                let formChangesContentHtml;
                const endingFeesHeading = getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.FeesEnding");
                const startingFeesHeading = getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.FeesStarting");
                const matchValue_18 = [isEmpty(suggestions_5.EndingFees), isEmpty(suggestions_5.StartingFees)];
                if (matchValue_18[0]) {
                    if (matchValue_18[1]) {
                        formChangesContentHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const children_68 = [(children_62 = [react.createElement("h5", {}, endingFeesHeading), warning(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.NoFeesWithAccountNr").split(""))], react.createElement("div", {}, ...children_62)), (children_66 = [react.createElement("h5", {}, startingFeesHeading), startingFees_1], react.createElement("div", {}, ...children_66))];
                        formChangesContentHtml = react.createElement(react.Fragment, {}, ...children_68);
                    }
                }
                else if (matchValue_18[1]) {
                    const children_77 = [(children_71 = [react.createElement("h5", {}, endingFeesHeading), endingFeesHtml], react.createElement("div", {}, ...children_71)), (children_75 = [react.createElement("h5", {}, startingFeesHeading), warning(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.NoFeesWithAccountNr").split(""))], react.createElement("div", {}, ...children_75))];
                    formChangesContentHtml = react.createElement(react.Fragment, {}, ...children_77);
                }
                else {
                    const children_59 = [(children_53 = [react.createElement("h5", {}, endingFeesHeading), endingFeesHtml], react.createElement("div", {}, ...children_53)), (children_57 = [react.createElement("h5", {}, startingFeesHeading), startingFees_1], react.createElement("div", {}, ...children_57)), cancellationPeriodMonthsAndBoundMonthsMsgHtml, moreThanOneStartingFeeSelectedMsgHtml, moreThanOneEndingFeeSelectedMsgHtml, requiredNrOfFeesSelectedHtml];
                    formChangesContentHtml = react.createElement(react.Fragment, {}, ...children_59);
                }
                const formChangesClasses = classNames(ofArray([["form__changes", true], ["form__changes--disabled", isDisabled_2]]));
                const noFeeManipulationMsgHtml = isDisabled_2 ? info(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType.NoFeeManipulation").split("")) : react.createElement(react.Fragment, {});
                changesToBeMadeHtml = react.createElement("div", {
                    className: formChangesClasses,
                }, formChangesContentHtml, noFeeManipulationMsgHtml);
                break;
            }
            default: {
                changesToBeMadeHtml = react.createElement(react.Fragment, {});
            }
        }
        bodyHtml_1 = react.createElement(react.Fragment, {}, productInputHtml_1, contractTypeInputHtml_1, dateSectionHtml_1, changesToBeMadeHtml);
        const modalHeaderHtml_1 = getModalHeader(getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.UpdateContractType"), (_arg_20) => {
            props_21.CloseModalFn();
        });
        const modalBodyHtml_1 = getModalBodyContainer((children_92 = toList_1(delay(() => {
            let children_91;
            const matchValue_19 = saveStatusState_1[0];
            switch (matchValue_19.tag) {
                case 1:
                case 3:
                case 2: {
                    let errorMessageHtml_1;
                    const matchValue_20 = saveStatusState_1[0];
                    if (matchValue_20.tag === 3) {
                        const children_83 = [error(matchValue_20.fields[0].split(""))];
                        errorMessageHtml_1 = react.createElement("div", {
                            className: "d-flex justify-content-center pb-4",
                        }, ...children_83);
                    }
                    else {
                        errorMessageHtml_1 = react.createElement(react.Fragment, {});
                    }
                    const historyLink_1 = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), ofArray(["Subscriptions", int32ToString(props_21.ContractNr)]), singleton("History")), 1);
                    return singleton_1((children_91 = toList_1(delay(() => append(singleton_1(getSavePanel("", singleton([(getTranslation_1("Common.Changing") + " ") + getTranslation_1("Common.SubscriptionForm"), saveStatusState_1[0]]))), delay(() => {
                        let children_88, children_86;
                        return append(((saveStatusState_1[0]).tag === 2) ? singleton_1((children_88 = [(children_86 = [getTranslation_1("CustomerContract.Invoicee.Subscriptions.Overview.GoToPlannedChanges")], react.createElement("a", {
                            ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.GoToPlannedChanges",
                            onClick: (_arg_21) => {
                                props_21.CloseModalFn();
                            },
                            id: "update-contract-type-navigate-history",
                            href: historyLink_1,
                        }, ...children_86))], react.createElement("p", {}, ...children_88))) : singleton_1(react.createElement(react.Fragment, {})), delay(() => singleton_1(errorMessageHtml_1)));
                    })))), react.createElement(react.Fragment, {}, ...children_91)));
                }
                default: {
                    return singleton_1(bodyHtml_1);
                }
            }
        })), react.createElement("div", {
            className: "update-contract-type__form",
        }, ...children_92)));
        const modalFooterHtml_1 = getModalFooterContainer((matchValue_22 = (saveStatusState_1[0]), (matchValue_22.tag === 1) ? modalMain(new ButtonProps(getTranslation_1("Common.Changing") + "...", defaultProps.Content, (value_8) => {
        }, true, defaultProps.Id, saveStatusState_1[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((matchValue_22.tag === 3) ? modalMain(new ButtonProps(getTranslation_1("Common.Close"), defaultProps.Content, (_arg_24) => {
            props_21.AfterSaveFn();
            props_21.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, saveStatusState_1[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((matchValue_22.tag === 2) ? modalMain(new ButtonProps(getTranslation_1("Common.Close"), defaultProps.Content, (_arg_24) => {
            props_21.AfterSaveFn();
            props_21.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, saveStatusState_1[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)) : ((children_94 = [modalCancel(new ButtonProps(getTranslation_1("Common.Cancel"), defaultProps.Content, (_arg_22) => {
            props_21.CloseModalFn();
        }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalMain(new ButtonProps(getTranslation_1("Common.Change"), defaultProps.Content, (_arg_23) => {
            const matchValue_23 = contractTypeSuggestionState[0];
            if (matchValue_23.tag === 2) {
                const suggestions_6 = matchValue_23.fields[0];
                const matchValue_24 = [filter((ef) => ef.IsSelected, suggestions_6.EndingFees), filter((sf) => sf.IsSelected, suggestions_6.StartingFees)];
                let pattern_matching_result_1, singleEndingFee_2, singleStartingFee_2;
                if (!isEmpty(matchValue_24[0])) {
                    if (isEmpty(tail(matchValue_24[0]))) {
                        if (!isEmpty(matchValue_24[1])) {
                            if (isEmpty(tail(matchValue_24[1]))) {
                                pattern_matching_result_1 = 0;
                                singleEndingFee_2 = head(matchValue_24[0]);
                                singleStartingFee_2 = head(matchValue_24[1]);
                            }
                            else if (length(matchValue_24[1]) > 1) {
                                pattern_matching_result_1 = 1;
                            }
                            else {
                                pattern_matching_result_1 = 3;
                            }
                        }
                        else if (length(matchValue_24[1]) > 1) {
                            pattern_matching_result_1 = 1;
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                    else if (!isEmpty(matchValue_24[1])) {
                        if (isEmpty(tail(matchValue_24[1]))) {
                            if (length(matchValue_24[0]) > 1) {
                                pattern_matching_result_1 = 2;
                            }
                            else {
                                pattern_matching_result_1 = 3;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 3;
                    }
                }
                else if (!isEmpty(matchValue_24[1])) {
                    if (isEmpty(tail(matchValue_24[1]))) {
                        if (length(matchValue_24[0]) > 1) {
                            pattern_matching_result_1 = 2;
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 3;
                    }
                }
                else {
                    pattern_matching_result_1 = 3;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        saveChangeContractType_1(selectedContractTypeCodeState_1[0], selectedStartDateState_1[0], singleEndingFee_2.FeeNr, singleStartingFee_2.FeeTemplateNr);
                        break;
                    }
                    case 1: {
                        break;
                    }
                    case 2: {
                        break;
                    }
                    case 3: {
                        saveChangeContractType_1(selectedContractTypeCodeState_1[0], selectedStartDateState_1[0], void 0, void 0);
                        break;
                    }
                }
            }
        }, (((isNullOrWhiteSpace(selectedContractTypeCodeState_1[0]) ? true : equals(contractTypeSuggestionState[0], new LoadState$2(1))) ? true : moreThanOneStartingFeesSelected) ? true : moreThanOneEndingFeesSelected) ? true : (!requiredNrOfFeesSelected), defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement(react.Fragment, {}, ...children_94)))))));
        return getModalContainer(new ModalSize(2), react.createElement("div", {
            className: "update-contract-type",
        }, modalHeaderHtml_1, modalBodyHtml_1, modalFooterHtml_1));
    }
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\UpdateContractType\\View.fs", 988);

